module.exports = __webpack_public_path__ + "js/3.aaa237df.worker.js"